import { Link as WebUILink } from '@stenajs-webui/elements';
import type { FC } from 'react';
import { modalRouteCreators } from '../../../common/routes/AppRoutes';
import { useLinkModalProps } from '../../../common/routes/useLinkModalProps';
import { trackEvent } from '../../../common/tracking/trackerService';
import { Link } from '../../../common-ui/Link';
import { useNotificationContext } from '../context/NotificationContext';

interface ShowDetailsLinkProps {
  action?: string;
  bookingNo: number;
}

export const ShowDetailsLink: FC<ShowDetailsLinkProps> = ({
  bookingNo,
  action = 'Show booking details',
}) => {
  const { trackerCategory, onRequestClose } = useNotificationContext();

  const bookingDetailsViewLinkProps = useLinkModalProps(
    modalRouteCreators.bookingDetailsView({ bookingNo }),
  );

  return (
    <Link
      {...bookingDetailsViewLinkProps}
      className={'t_open_details'}
      onClick={() => {
        onRequestClose?.();
        trackEvent({ category: trackerCategory, action });
      }}
      render={props => <WebUILink {...props}>{bookingNo}</WebUILink>}
    />
  );
};
